export default function outcome(value) {
  return value || 'Time'
}
